/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon32Regular = forwardRef('CheckSquareCutIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M5 8.5A3.5 3.5 0 0 1 8.5 5H19a1 1 0 1 0 0-2H8.5A5.5 5.5 0 0 0 3 8.5v15A5.5 5.5 0 0 0 8.5 29h15a5.5 5.5 0 0 0 5.5-5.5V18a1 1 0 1 0-2 0v5.5a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 23.5v-15Z" }),
        React.createElement("path", { d: "M28.457 8.23a1 1 0 0 0-1.414-1.414L16.31 17.55a1.5 1.5 0 0 1-2.122 0l-3.982-3.983a1 1 0 0 0-1.414 1.415l3.982 3.982a3.5 3.5 0 0 0 4.95 0L28.457 8.23Z" })));
});
